import React from 'react';
import "./crmplatform.css"

const CrmPlatform = () => {
  return (
    <div className='crmplatform_main_div'>
      <h1>The CRM Platform Your Whole Business Will Love</h1>
      <div>
        <p>HubSpot’s CRM platform has all the tools and integrations you need for marketing, sales, content management, and customer service. Each product in the platform is powerful alone, but the real magic happens when you use them together.</p>
      </div>
      <div className='GetFreeCrm'>
        <div className='GetFree1'>Get free CRM</div>
        <div className='GetFree2'>Demo premium CRM</div>
      </div>
    </div>
  )
}

export default CrmPlatform
